export const SameAsUrls = [
  "https://en.wikipedia.org/wiki/South_China_Morning_Post",
  "https://www.facebook.com/scmp/",
  "https://www.instagram.com/scmpnews",
  "https://www.linkedin.com/company/south-china-morning-post",
  "https://www.youtube.com/southchinamorningpost",
  "https://x.com/SCMPNews",
];
